import React, { useState, useEffect } from 'react';
import { Car, MapPin, Clock, Calendar, User, ArrowRight, Users } from 'lucide-react';
import axiosInstance from '../../utils/axiosConfig';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const TaxiRecepcionWidget = () => {
    const { user } = useAuth();
    const [solicitudes, setSolicitudes] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const isRecepcion = user?.role === 'recepcion';

    useEffect(() => {
        if (!isRecepcion) return;
        const fetchPendientes = async () => {
            try {
                const res = await axiosInstance.get('/api/taxi-requests/todas', { params: { estado: 'pending' } });
                if (res.data.success) setSolicitudes(res.data.solicitudes);
            } catch (err) {
                console.error('Error fetching taxi pendientes:', err);
            } finally {
                setLoading(false);
            }
        };
        fetchPendientes();
    }, [isRecepcion]);

    if (!isRecepcion || loading || solicitudes.length === 0) return null;

    return (
        <section className="rounded-2xl overflow-hidden border border-amber-200 shadow-sm">
            {/* Header */}
            <div className="bg-gradient-to-r from-amber-500 to-orange-600 px-5 py-4 text-white">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-xl bg-white/20 backdrop-blur-sm flex items-center justify-center">
                            <Car size={20} />
                        </div>
                        <div>
                            <h3 className="font-bold text-lg">Taxis Pendientes</h3>
                            <p className="text-white/80 text-sm">{solicitudes.length} solicitud{solicitudes.length !== 1 ? 'es' : ''} por confirmar</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Lista compacta */}
            <div className="bg-amber-50 divide-y divide-amber-100">
                {solicitudes.slice(0, 4).map(sol => (
                    <div key={sol.id} className="px-5 py-3 flex items-center gap-3">
                        <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center flex-shrink-0 border border-amber-200">
                            <User size={14} className="text-gray-500" />
                        </div>
                        <div className="flex-1 min-w-0">
                            <p className="text-sm font-medium text-gray-900 truncate">{sol.empleado}</p>
                            <p className="text-xs text-gray-500 truncate">{sol.origin} → {sol.destination}</p>
                        </div>
                        <div className="text-right flex-shrink-0">
                            <p className="text-xs font-medium text-gray-700">
                                {sol.date ? new Date(sol.date + 'T00:00:00').toLocaleDateString('es-VE', { day: 'numeric', month: 'short' }) : ''}
                            </p>
                            <p className="text-xs text-gray-500">{sol.time}</p>
                        </div>
                    </div>
                ))}
                {solicitudes.length > 4 && (
                    <div className="px-5 py-2 text-center">
                        <span className="text-xs text-amber-600 font-medium">+{solicitudes.length - 4} más</span>
                    </div>
                )}
            </div>

            {/* Botón */}
            <div className="bg-amber-50 px-5 pb-4 pt-1">
                <button
                    onClick={() => navigate('/solicitud-taxi?tab=manage')}
                    className="w-full py-3 rounded-xl bg-gray-900 text-white font-medium flex items-center justify-center gap-2 hover:bg-gray-800 transition-colors text-sm"
                >
                    Gestionar solicitudes
                    <ArrowRight size={16} />
                </button>
            </div>
        </section>
    );
};

export default TaxiRecepcionWidget;
